export default __webpack_public_path__ + "static/media/p26.b1e39e58.jpg";